var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.02 20.53C9.69 20.53 7.36 20.16 5.15 19.42C4.31 19.13 3.67 18.54 3.39 17.77C3.1 17 3.2 16.15 3.66 15.39L4.81 13.48C5.05 13.08 5.27 12.28 5.27 11.81V8.92C5.27 5.2 8.3 2.17 12.02 2.17C15.74 2.17 18.77 5.2 18.77 8.92V11.81C18.77 12.27 18.99 13.08 19.23 13.49L20.37 15.39C20.8 16.11 20.88 16.98 20.59 17.77C20.3 18.56 19.67 19.16 18.88 19.42C16.68 20.16 14.35 20.53 12.02 20.53ZM12.02 3.67C9.13 3.67 6.77 6.02 6.77 8.92V11.81C6.77 12.54 6.47 13.62 6.1 14.25L4.95 16.16C4.73 16.53 4.67 16.92 4.8 17.25C4.92 17.59 5.22 17.85 5.63 17.99C9.81 19.39 14.24 19.39 18.42 17.99C18.78 17.87 19.06 17.6 19.19 17.24C19.32 16.88 19.29 16.49 19.09 16.16L17.94 14.25C17.56 13.6 17.27 12.53 17.27 11.8V8.92C17.27 6.02 14.92 3.67 12.02 3.67Z",
    fill: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.88 3.94C13.81 3.94 13.74 3.93 13.67 3.91C13.38 3.83 13.1 3.77 12.83 3.73C11.98 3.62 11.16 3.68 10.39 3.91C10.11 4 9.81 3.91 9.62 3.7C9.43 3.49 9.37 3.19 9.48 2.92C9.89 1.87 10.89 1.18 12.03 1.18C13.17 1.18 14.17 1.86 14.58 2.92C14.68 3.19 14.63 3.49 14.44 3.7C14.29 3.86 14.08 3.94 13.88 3.94Z",
    fill: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.02 22.81C11.03 22.81 10.07 22.41 9.37 21.71C8.67 21.01 8.27 20.05 8.27 19.06H9.77C9.77 19.65 10.01 20.23 10.43 20.65C10.85 21.07 11.43 21.31 12.02 21.31C13.26 21.31 14.27 20.3 14.27 19.06H15.77C15.77 21.13 14.09 22.81 12.02 22.81Z",
    fill: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notification.6ab4e336c7f67e6a52565d51035b8b33.svg";